import { Button, MenuItem, ButtonProps, Typography } from '@mui/material';
import { FC } from 'react';

const ControlActionButton: FC<
  React.PropsWithChildren<ControlActionButtonProps>
> = ({ label, ...rest }) => {
  return (
    <MenuItem sx={{ backgroundColor: 'transparent', m: 0, p: 0 }}>
      <Button
        {...rest}
        variant='text'
        sx={{ textTransform: 'none', ...rest.sx }}>
        <Typography variant='caption' color='inherit'>
          {label}
        </Typography>
      </Button>
    </MenuItem>
  );
};

export interface ControlActionButtonProps extends Omit<ButtonProps, 'variant'> {
  label: string;
}

export default ControlActionButton;
